function generateTimes(lowerBound, upperBound) {
  let pad = x => x.toString().padStart(2, '0');
  let arr = [];
  for (let h = 0; h<24; h++) {
    if (h < lowerBound)
      continue;
    if (h > upperBound)
      break;
    for (let m = 0; m<60; m = m+15) {
      let t = pad(h) + ':' + pad(m);
      arr.push({value: t, label: t});
    }
  }
  return arr;
}

module.exports = {
  type: 'attachments',
  id: 'scans',
  icon: 'paperclip',
  title: {
    de: 'Datenbereitstellung',
    en: 'Data upload'
  },
  introOff: {
    style: 'info',
    icon: 'fas fa-info',
    de: 'Wenn die Option "Ich möchte analoge Modelle versenden" gewählt wurde, wird kein Upload benötigt',
    en: 'No upload is required if you select option "analog model"'
  },
  form: [{
    id: 'modelType',
    type: 'radio',
    required: true,
    label: {
      de: 'Wenn die Option "Ich möchte analoge Modelle versenden" gewählt wurde, wird kein Upload benötigt',
      en: 'No upload is required if you select option "analog model"'
    },
    options: [{
        value: 'digital',
        label: {
          de: 'Ich möchte <b>digitale Modelldaten</b> versenden',
          en: 'I want to send <b>digital models</b>'
        },
        info: {
          de: 'Ein Abholauftrag wird bei der Bestellung automatisch an UPS übermittelt',
          en: 'We will automatically place an order at UPS to pick up your parcel'
        }
      },
      {
        value: 'analog',
        label: {
          de: 'Ich möchte <b>analoge Modelle</b> versenden',
          en: 'I want to send <b>analog models</b>'
        },
        info: {
          de: 'Ein Abholauftrag wird bei der Bestellung automatisch an UPS übermittelt',
          en: 'We will automatically place an order at UPS to pick up your parcel'
        },
      }
    ]
    },
    {
      id: 'modelPickup',
      label: {de: 'Modellabholung', en: 'Model pickup'},
      type: 'select',
      required: true,
      options: [
        {value: 'yes', label: {de: 'Abholung', en: 'Yes, CreaCam shall pick up'}},
        {value: 'yes0', label: {de: 'Abholung schon gebucht', en: 'Yes, I already ordered CreaCam to pick up'}},
        {value: 'no', label: {de: 'Selbstanlieferung', en: 'No, we will deliver ourselves'}},
      ],
      showIf: {
        $eq: {modelType: 'analog'}
      }
    },
    {
      id: 'modelPickupService',
      label: {de: 'Versandart bei Abholung', en: 'Shipping method for pickup'},
      type: 'select',
      required: true,
      options: [
        {value: 'V.1', label: {de: 'Standard Versand', en: 'Default delivery'}, itemnum: 'V.1'},
        {value: 'V.2', label: {de: 'Terminzustellung', en: 'Scheduled delivery'}, itemnum: 'V.2'},
        {value: 'V.3', label: {de: 'Wochenendzustellung ab 8 Uhr', en: 'Weekend delivery full day'}, itemnum: 'V.3'},
        {value: 'V.4', label: {de: 'Wochenendzustellung ab 10 Uhr', en: 'Weekend delivery noon'}, itemnum: 'V.4'},
      ],
      showIf: {
        $eq: {modelPickup: 'yes'}
      }
    },
    {
      id: 'modelPickupStart',
      label: {de: 'Abholzeit Anfang (3h Zeitfenster)', en: 'Pickup time start (3h time window)'},
      type: 'select',
      required: true,
      options: generateTimes(8, 18),
      showIf: {
        $eq: {modelPickup: 'yes'}
      }
    },
    /*{
      id: 'modelPickupEnd',
      label: {de: 'Abholzeit Ende', en: 'Pickup time end'},
      type: 'select',
      required: true,
      options: generateTimes(10, 20),
      showIf: {
        $eq: {modelType: 'analog'}
      }
    }*/
  ],

  // Global settings and restrictions
  fileTypes: null, // Everything is permitted
  sizeLimit: null, // Size limit in MB
  fileLimit: null, // No upload limit

  classes: {
    scans: {
      fileTypes: ['.stl', '.zip'],
      fileLimit: null,
      requires: 1, // 1 file is required
      secure: true,
      showIf: {
        modelType: 'digital'
      },
      title: {
        de: 'Digitale Modelldaten',
        en: 'Digital model data'
      },
      placeholder: {
        de: 'Scan-Upload',
        en: 'Scan-Upload'
      }
    }
  }
}
